import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { SidebarComponent } from '../../../../components/sidebar/sidebar.component';
import { MobileHeaderComponent } from '../../../../components/mobile-header/mobile-header.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-step-4',
  standalone: true,
  imports: [CommonModule, MatButtonModule, SidebarComponent, MobileHeaderComponent, TranslateModule],
  templateUrl: './step-4.component.html',
  styleUrl: './step-4.component.scss'
})
export class Step4Component {

  constructor() { }

  goBack() { 
    console.log('Going back...');
  }

  loading = false;

}
